import React, { useEffect, useState, useRef } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import SelectFilter from "../../../../components/SelectFilter";
import DataTableGP from "../../../../components/Tables/tablesGP";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./styles.css";

const QuestionAnswer = ({ setFunc, question, index, sheet, token }) => {
  const changeAnswer = value => {
    const newAnswerSheet = { ...sheet };
    newAnswerSheet.questions[index].current_answer_given = value;

    setFunc(newAnswerSheet);
    setCurrentValue(value);
  };

  const [currentValue, setCurrentValue] = useState(
    question.current_answer_given ??
      question.previous_answer_given ??
      question.previous_question_answer_type
  );

  return (
    <div
      className="d-flex justify-content-between my-1 w-100"
      // style={{ maxWidth: "420px", minWidth: "420px" }}
    >
      {Array.from({ length: 5 }).map((_, optionIndex) => (
        <div
          className={`${
            currentValue === optionIndex + 1
              ? "question-answer-letter-container-active"
              : "question-answer-letter-container"
          } mr-2`}
          onClick={() => changeAnswer(optionIndex + 1)}
        >
          <span
            className={
              currentValue === optionIndex + 1
                ? "question-answer-letter-active"
                : "question-answer-letter"
            }
          >
            {String.fromCharCode(65 + optionIndex)}
          </span>
        </div>
      ))}

      <div
        className={`${
          currentValue === "double_marked"
            ? "question-answer-letter-container-compact-active"
            : "question-answer-letter-container-compact"
        } mr-2`}
        onClick={() => changeAnswer("double_marked")}
      >
        <span
          className={
            currentValue === "double_marked"
              ? "question-answer-letter-compact-active"
              : "question-answer-letter-compact"
          }
        >
          Marcação Múltipla
        </span>
      </div>

      <div
        className={`${
          currentValue === "blank"
            ? "question-answer-letter-container-compact-active"
            : "question-answer-letter-container-compact"
        }`}
        onClick={() => changeAnswer("blank")}
      >
        <span
          className={
            currentValue === "blank"
              ? "question-answer-letter-compact-active"
              : "question-answer-letter-compact"
          }
        >
          Sem Resposta
        </span>
      </div>
    </div>
  );
};

const EvaluationBankGradePanel = props => {
  let [loading, setLoading] = useState();
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [yearList, setYearList] = useState(null);

  let [groupList, setGroupList] = useState();
  let [groupID, setGroupID] = useState(
    props.general.active_roles.group_id ?? null
  );

  let [regionList, setRegionList] = useState();
  let [regionID, setRegionID] = useState(
    props.general.active_roles.region_id ?? null
  );

  let [schoolList, setSchoolList] = useState();
  let [schoolID, setSchoolID] = useState(
    props.general.active_roles.school_id ?? null
  );

  let [classroomList, setClassroomList] = useState();
  let [classroomID, setClassroomID] = useState();

  let [evaluationList, setEvaluationList] = useState();
  let [activityId, setActivityId] = useState();

  let [trailLoading, setTrailLoading] = useState(false);
  let [usersTrailList, setUsersTrailList] = useState();

  let [studentListPage, setStudentListPage] = useState(1);
  let [studentListSize, setStudentListSize] = useState();
  let [sizePerPage, setSizePerPage] = useState(10);

  let [toggleShowlAll, setToggleShowAll] = useState(true);

  let [inputModal, setInputModal] = useState(false);
  let [answerSheet, setAnswerSheet] = useState();

  let [userId, setUserId] = useState();

  const isFirstRender = useRef(true);

  useEffect(() => {
    let arrYear = [];
    for (let i = 2; i >= 0; i--) {
      let obj = {
        label: currentYear - i,
        value: currentYear - i
      };
      arrYear.push(obj);
    }
    setYearList(arrYear);

    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        let group = props.general.active_roles.group_id ?? 0;
        let region = props.general.active_roles.region_id ?? 0;
        let school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(region, group);
          }

          if (school) {
            setSchoolID(school);

            getClassList(school);
          }
        }
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!isFirstRender.current) {
      setClassroomID(0);
      setActivityId(0);
      getClassList(schoolID);
    } else {
      isFirstRender.current = false;
    }
  }, [currentYear]);

  const [isInitialRender, setIsInitialRender] = useState(true);
  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
    } else {
      getStudentList();
    }
  }, [sizePerPage, studentListPage, toggleShowlAll]);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      setActivityId(0);
      classroomID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/region/listRegionFilter/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const regionList = resp.data?.data.map(region => ({
            label: region.name,
            value: region.id
          }));
          setRegionList(regionList);
        });
    } catch {
      setRegionID(0);
      setSchoolID(0);
      classroomID(0);
    }
  };

  const getSchools = async (id, groupID) => {
    if (!id) {
      setSchoolID(0);
      classroomID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/school/listSchoolFilter/${groupID}/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const schoolList = resp.data?.data.map(school => ({
            label: school.name,
            value: school.id
          }));
          setSchoolList(schoolList);
        });
    } catch {
      setSchoolID(0);
      classroomID(0);
    }
  };

  const getClassList = async schoolID => {
    const year = new Date().getFullYear();
    const { user } = props;

    let params = {
      start: `${currentYear || year}-01-01T00:00:00`,
      end: `${(currentYear || year) + 1}-01-01T00:00:00`
    };

    // Se o usuário não tiver alguma role de Administrador Escolar
    if (!user.user_roles.some(item => item.role_id === 4)) {
      params.user = `${user.user.id}`;
    }

    axios
      .get(
        `${URL.api}community/room/listOnly?class=true&school[]=${schoolID}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      )
      .then(resp => {
        const classroomList = resp.data?.data.map(classroom => ({
          label: classroom.name,
          value: classroom.id
        }));
        setClassroomList(classroomList);
      });
  };

  const getEvaluations = (groupID, regionID, schoolID, classroomID) => {
    try {
      let url = `${URL.api}community/room/listEvaluations?group_id=${groupID}&region_id=${regionID}&school_id=${schoolID}&room_id=${classroomID}&adr=true`;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const evaluationList = resp.data?.data
            .filter(trail => trail.private === false)
            .map(trail => ({
              label: trail.activity_name,
              value: trail.activity_id
            }));
          setEvaluationList(evaluationList);
        });
    } catch {
      setActivityId(0);
    }
  };

  const toggleShowAllUsers = () => {
    setToggleShowAll(!toggleShowlAll);
    if (toggleShowlAll) {
      setStudentListPage(1);
      setSizePerPage(1000);
    } else {
      setStudentListPage(1);
      setSizePerPage(10);
    }
  };

  const getStudentList = async () => {
    setTrailLoading(true);
    await axios
      .get(
        `${URL.api}evaluation/bank/usersByEvaluationInRoom?activity_id=${activityId}&room_id=${classroomID}&page=${studentListPage}&offset=${sizePerPage}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      )
      .then(resp => {
        let userList = [];

        // se tem list_end e não é processed = Em processamento

        resp?.data.data.forEach(user => {
          let newUser = user;

          // Realização
          if (user.teacher_inserted === false) {
            newUser.teacher_inserted = "Online";
          } else if (user.teacher_inserted == null) {
            newUser.teacher_inserted = "";
          } else {
            newUser.teacher_inserted = "Impresso";
          }

          // Nota
          newUser.grade = "Avaliação não realizada";
          if (user.processed) {
            newUser.grade = user.final_grade;
          } else if (user.list_start) {
            newUser.grade = "Em processamento";
          }

          userList.push(newUser);
        });

        setUsersTrailList(userList);
        setStudentListPage(resp.data.meta.current_page);
        setStudentListSize(resp.data.meta.total);
        setTrailLoading(false);
      });
  };

  const sendAnswerSheet = () => {
    let obj = {
      activity_id: activityId,
      user_id: userId,
      room_id: classroomID,

      answers: answerSheet.questions.map(answer => ({
        question_id: answer.question_id,
        question_answer_type: ["blank", "double_marked"].includes(
          answer.current_answer_given
        )
          ? answer.current_answer_given
          : "normal",
        option: ["blank", "double_marked"].includes(answer.current_answer_given)
          ? null
          : answer.current_answer_given ?? answer.previous_answer_given ?? null
      }))
    };

    axios
      .post(`${URL.api}evaluation/bank/grade_entry/finish`, obj, {
        headers: { Authorization: `Bearer ${props.user.token}}` }
      })
      .then(() => {
        setInputModal(false);
        setAnswerSheet(null);
        getStudentList();
      });
  };

  const openModal = (activityID, userID) => {
    axios
      .post(
        `${URL.api}evaluation/bank/grade_entry/answers_sheet`,
        {
          activity_id: activityID,
          user_id: userID
        },
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      )
      .then(resp => {
        setUserId(userID);
        setAnswerSheet(resp.data.data);
        setInputModal(true);
      });
  };

  const allQuestionsAnswered =
    answerSheet &&
    answerSheet.questions.every(
      q => (q.current_answer_given ?? q.previous_answer_given) != null
    );

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />
      <CModal
        show={inputModal}
        centered
        size="lg"
        onClose={() => {
          setInputModal(false);
          setAnswerSheet(null);
        }}
        className="p-5"
      >
        {/* Mudar aqui */}
        <CModalHeader className="d-flex flex-column">
          <CModalTitle className="answer-sheet-modal-title-gradepanel">
            Lançamento de Gabarito
          </CModalTitle>
          <span className="answer-sheet-modal-subtitle mt-2">
            Selecione as alternativas marcadas.
          </span>
        </CModalHeader>
        <CModalBody>
          {answerSheet &&
            answerSheet?.questions.map((question, index) => (
              <div
                className="d-flex align-items-center w-100 justify-content-between text-right"
                style={{ padding: "5px 20px" }}
              >
                <h3 className="m-0 mr-2 w-100">{index + 1}.</h3>
                <QuestionAnswer
                  setFunc={setAnswerSheet}
                  question={question}
                  sheet={answerSheet}
                  index={index}
                  token={props.user.token}
                />
              </div>
            ))}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="secondary"
            onClick={() => {
              setInputModal(false);
              setAnswerSheet(null);
            }}
          >
            Cancelar
          </CButton>
          <div style={{ position: "relative", display: "inline-block" }}>
            <CButton
              color="primary"
              onClick={e => {
                if (allQuestionsAnswered) {
                  sendAnswerSheet();
                } else {
                  e.preventDefault();
                  toastr.warning(
                    "Atenção",
                    "Preencha todas as alternativas antes de confirmar."
                  );
                }
              }}
              style={
                !allQuestionsAnswered
                  ? { opacity: 0.6, cursor: "not-allowed" }
                  : {}
              }
            >
              Confirmar
            </CButton>
          </div>
        </CModalFooter>
      </CModal>

      <CCard>
        <CCardHeader>
          <CCardTitle>Painel de Notas</CCardTitle>
          <CCardSubtitle className="small text-muted">
            Visualize as notas das avaliações em andamento
          </CCardSubtitle>
        </CCardHeader>
        <CCardBody>
          {loading ? (
            <Loading />
          ) : (
            <>
              <CCard className="d-flex justify-items-center justify-content-center p-4">
                <CRow>
                  <CCol sm="12" md="12">
                    <CRow>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Grupo"
                          icon="fa-users"
                          placeholder="Selecione um grupo"
                          value={groupID}
                          setFunction={id => {
                            setGroupID(id);
                            getRegions(id);
                          }}
                          options={groupList}
                          disabled={!!props.general.active_roles.group_id}
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Regiões"
                          icon="fa-globe"
                          placeholder="Todas"
                          value={regionID}
                          setFunction={id => {
                            setRegionID(id);
                            getSchools(id, groupID);
                          }}
                          options={regionList}
                          disabled={
                            !groupID || !!props.general.active_roles.region_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Escolas"
                          icon="fa-institution"
                          placeholder="Todas"
                          value={schoolID}
                          setFunction={id => {
                            setSchoolID(id);
                            getClassList(id);
                          }}
                          options={schoolList}
                          disabled={
                            !regionID || !!props.general.active_roles.school_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Ano"
                          icon="fa-graduation-cap"
                          placeholder="Selecione um ano"
                          value={currentYear}
                          setFunction={id => {
                            setCurrentYear(id);
                          }}
                          options={yearList}
                          disabled={!schoolID}
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Turmas"
                          icon="fa-graduation-cap"
                          placeholder="Selecione uma turma"
                          value={classroomID}
                          setFunction={id => {
                            setClassroomID(id);
                            getEvaluations(groupID, regionID, schoolID, id);
                          }}
                          options={classroomList}
                          disabled={!schoolID || !classroomList}
                        />
                      </CCol>
                      <CCol sm="12" md="3" className="my-2">
                        <SelectFilter
                          title="Avaliação"
                          icon="fa-code-fork"
                          placeholder="Selecione uma avaliação"
                          value={activityId}
                          setFunction={id => {
                            setActivityId(id);
                          }}
                          options={evaluationList}
                          disabled={!groupID || !classroomID}
                        />
                      </CCol>
                      <CCol
                        sm="12"
                        md="2"
                        className="d-flex justify-content-center my-2 align-items-end"
                      >
                        <CButton
                          color="primary"
                          className="d-flex justify-content-center align-items-center rounded-left w-100"
                          onClick={() => getStudentList()}
                          disabled={!groupID || !activityId}
                        >
                          <i className="fa fa-filter" />
                          &nbsp; Filtrar
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCard>
              {usersTrailList ? (
                <>
                  <DataTableGP // O componente original é o DataTable, foi trocado para não importar mais o "Exportar PDF"
                    isRoomUsersPage
                    toggleShowAllUsersActivated={toggleShowlAll}
                    toggleShowAllUsers={toggleShowAllUsers}
                    noSort
                    list={usersTrailList}
                    title="Estudantes"
                    action
                    answerKeyAction={row => openModal(activityId, row.id)}
                    btnAnswerKeyEvaluationBank
                    subtitle="Lista de estudantes participantes da turma"
                    remote
                    currentPage={studentListPage}
                    totalItems={studentListSize}
                    perPage={sizePerPage}
                    onPageChange={page => {
                      setStudentListPage(page);
                    }}
                    onSizePerPageList={size => {
                      setSizePerPage(size);
                    }}
                    header={[
                      { name: "name", denomination: "Estudante" },
                      { name: "grade", denomination: "Nota" },
                      { name: "teacher_inserted", denomination: "Realização" }
                    ]}
                  />
                </>
              ) : (
                <>
                  {!trailLoading ? (
                    <p className="w-100 text-center">
                      Selecione ao menos o grupo e uma ADR para obter o
                      resultado.
                    </p>
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </>
          )}
        </CCardBody>
      </CCard>
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationBankGradePanel);
